<template>
  <section id="portfolio">
    <div class="container wow fadeInUp">
      <div>
        <div class="pro">
          <div class="pro_pic">
            <!--<router-link to="/product">-->
            <router-link :to="{path: `/product/247`}">
              <img src="../../assets/products/classify_1.jpg" width="100%" />
            </router-link>
            <p class="pro_text">链轮</p>
          </div>
          <div class="pro_pic">
            <!--<router-link to="/product">-->
            <router-link :to="{path: `/product/49`}">
              <img src="../../assets/products/classify_2.jpg" width="100%" />
            </router-link>
            <p class="pro_text">滚子链</p>
          </div>
          <div class="pro_pic">
            <!--<router-link to="/product">-->
            <router-link :to="{path: `/product/326`}">
              <img src="../../assets/products/classify_3.jpg" width="100%" />
            </router-link>
            <p class="pro_text">齿条</p>
          </div>
        </div>
        <div class="pro">
          <div class="pro_pic">
            <!--<router-link to="/product">-->
            <router-link :to="{path: `/product/73`}">
              <img src="../../assets/products/classify_4.jpg" width="100%" />
            </router-link>
            <p class="pro_text">惰轮</p>
          </div>
          <div class="pro_pic">
            <!--<router-link to="/product">-->
            <router-link :to="{path: `/product/254`}">
              <img src="../../assets/products/classify_5.jpg" width="100%" />
            </router-link>
            <p class="pro_text">联轴器</p>
          </div>
          <div class="pro_pic">
            <!--<router-link to="/product">-->
            <router-link :to="{path: `/product/295`}">
              <img src="../../assets/products/440-2023.png" width="100%" />
            </router-link>
            <p class="pro_text">同步带轮</p>
          </div>
<!--          <div class="pro_pic">-->
<!--            &lt;!&ndash;<router-link to="/product">&ndash;&gt;-->
<!--            <router-link :to="{path: `/product/53`}">-->
<!--              <img src="../../assets/products/classify_7.jpg" width="100%" />-->
<!--            </router-link>-->
<!--            <p class="pro_text">截链器</p>-->
<!--          </div>-->
<!--          <div class="pro_pic">-->
<!--            &lt;!&ndash;<router-link to="/product">&ndash;&gt;-->
<!--            <router-link :to="{path: `/product/257`}">-->
<!--              <img src="../../assets/products/348-2023.png" width="100%" />-->
<!--            </router-link>-->
<!--            <p class="pro_text">树脂导轨</p>-->
<!--          </div>-->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'hello',
    components: {
    },
    data () {
      return {
        msg: 'hello'
      }
    }
  }
</script>
<style type="text/scss" rel="stylesheet/scss" lang="scss">
.pro .pro_pic{
  width: 31%;
  display: inline-block;
  border: solid 1px #cccccc;
  margin-right: 5px;
  margin-bottom: 30px;
  padding: 10px 0;
  img{
    height: 120px;
    width: auto;
  }
  p{
    padding: 5px 0;
  }
}
@media only screen and (max-width: 768px){
  .pro{
    overflow: hidden;
    display: flex;
    .pro_text{
      font-size: 12px;
    }
  }
  .pro .pro_pic{
    box-sizing: border-box;
    width: 25%;
    margin: 0 2px 10px 2px;
    padding: 5px 0;
    img{
      height: 45px;
      width: auto;
    }
  }
  .pro .pro_pic:nth-child(2n){
    /*float: left;*/
  }
  .pro .pro_pic:nth-child(2n+1){
    /*float: right;*/
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/ProItem.vue